export default __webpack_public_path__ + "static/media/moodGood.588e1740.png";